<app-navbar/>
<div class="app-layout">
  <app-menu-vertical class="sidebar"/>
  <div class="content-area">
    <app-secondary-navbar/>
    @if (breadcrumbService.hasBreadcrumbs()) {
      <p-breadcrumb 
        [model]="breadcrumbService.breadcrumbs()" 
        [home]="home"
        styleClass="breadcrumb-custom">
      </p-breadcrumb>
    }
    <main class="main-content">
      <router-outlet />
    </main>
  </div>
</div>